import { useCompoundBody } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { Box, Cylinder, ObjectProps, useDragConstraint } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useCompoundBody(() => ({
    mass: 1,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { args: [3.7, 2.2, 0.1], mass: 1, type: 'Box' },
    ], 
    type: 'Dynamic'
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind}>
      <Box args={[3.7, 2.2, 0.1]} color="#2a2a2a" />
      <Box position={[0.1, 0, 0.0005]} args={[  3, 1.6, 0.1]} />
      <Box position={[0.1, 0, 0.0005]} args={[  3, 1.6, 0.1]} />
      <Box position={[-1.7, 0, 0.0005]} args={[  0.1, 0.2, 0.1]} />

      <Cylinder position={[-1.7,  0.3 , 0.0005]} args={[0.05, 0.05, 0.1]} rotation={[Math.PI / 2, 0, 0]} />
      <Cylinder position={[-1.7,  0.45, 0.0005]} args={[0.05, 0.05, 0.1]} rotation={[Math.PI / 2, 0, 0]} />
      <Cylinder position={[-1.7,  0.6 , 0.0005]} args={[0.05, 0.05, 0.1]} rotation={[Math.PI / 2, 0, 0]} />

      <Cylinder position={[-1.7, -0.3 , 0.0005]} args={[0.05, 0.05, 0.1]} rotation={[Math.PI / 2, 0, 0]} />
      <Cylinder position={[-1.7, -0.45, 0.0005]} args={[0.05, 0.05, 0.1]} rotation={[Math.PI / 2, 0, 0]} />
      <Cylinder position={[-1.7, -0.6 , 0.0005]} args={[0.05, 0.05, 0.1]} rotation={[Math.PI / 2, 0, 0]} />
    </group>
  );
};
